// extracted by mini-css-extract-plugin
export default {"wrapper":"WidthLimiter_wrapper__hzryu"};